import { FilterOperatorEnum } from 'domains/appDomain';

export const PLATFORM_FORM_ITEM_LAYOUT = {
  labelCol: { span: 8 },
  wrapperCol: { span: 10 },
};

export const PLATFORM_FORM_ACTION_LAYOUT = {
  labelCol: { span: 7 },
  wrapperCol: { span: 16, offset: 7 },
};

export const DEFAULT_DRAWER_WIDTH = 640;

export const JOB_INSIDE_PAGE_MAX = 5000;

export const UPLOAD_FILE_ADDRESS_PREFIX =
  process.env.REACT_APP_UPLOAD_URL_PREFIX ||
  'https://revshop-test.s3.us-west-1.amazonaws.com/';

export const BALANCE_SDK_URL =
  process.env.REACT_APP_BALANCE_SDK_URL ||
  'https://checkout-v2.sandbox.getbalance.com/sdk-latest.js';

export const UPLOAD_FILE_THUMBNAIL_ADDRESS_PREFIX =
  process.env.REACT_APP_THUMBNAIL_URL_PREFIX ||
  'https://revshop-test-thumbnails.s3.us-west-1.amazonaws.com/';

export const REACT_APP_DEMO_FLAG =
  (process.env.REACT_APP_SETTING_FLAG || '') === 'demo';

export const REACT_APP_DEVELOP_FLAG =
  (process.env.REACT_APP_SETTING_FLAG || 'develop') === 'develop';

export const REACT_APP_PRODUCTION_FLAG =
  (process.env.REACT_APP_SETTING_FLAG || '') === 'production';

export const SHIPPING_SPECIAL_DELIVERY = 'Special Delivery';

export const SHIPPING_SUPPLIER_DELIVERY = 'Supplier Shipping/Delivery';

export const SHIPPING_WILL_CALL = 'Will Call';

export const INTERNAL_DISTRIBUTION = 'Internal Distribution';

export const Customize = 'Customize';

export const NONSTANDARD_SHIPPING_METHODS = {
  Will_Call: SHIPPING_WILL_CALL,
  Special_Delivery: SHIPPING_SPECIAL_DELIVERY,
  Internal_Distribution: INTERNAL_DISTRIBUTION,
  Customize: Customize,
};

export const PAPER_COLOR_WHITE = 'white';

export const NOPROOF_DESCRIPTION = 'PDF proof - None';

export const SKU_TYPE_NAME_PACKAGING = 'Packaging';

export const DEBOUNCE_TIME = 800;

export const PRECONFIG_SKUID = 5001;

export const JOB_MAX_QUANTITY = 99999999;

export const MIN_PCT = -99;

export const MIN_PRICE = 0;

export const PICTURE_REGULAR =
  /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|apng|avif|cur|jfif|pjpeg|pjp|svg|tiff|webp)$/i;

export const UPLOAD_ACCEPT =
  '.ai,.docx,.doc,.eps,.gif,.indd,.jpeg,.jpg,.pdf,.png,.ppt,.pptx,.psd,.rar,.svg,.tif,.tiff,.xls,.xlsx,.zip';

export const JOB_FILE_MAX_NUM = 50;

export const JOB_MAX_QUANTITY_LENGTH = 5;

export const MAX_INT_VALUE = 0x7fffffff;

export const UPLOAD_FILE_NAME_MAX_LENGTH = 100;

export const JOB_NAME_MAX_LENGTH = 100;
export const NAME_MAX_LENGTH = 100;

export const FIRST_NAME_MAXLENGTH = 26;
export const LAST_NAME_MAXLENGTH = 26;
export const EMAIL_MAXLENGTH = 254;
export const INPUT_NORMAL_MAX_LENGTH = 255;

export const SHIPPING_STATUS_DISPLAY: { [index: string]: string } = {
  IN_TRANSIT: 'In Transit',
  DELIVERED: 'Delivered',
  EXCEPTION: 'Exception',
};

export const FILTER_NOT_EXISTS = {
  operator: FilterOperatorEnum.NOT_EXISTS,
  values: [],
};

export const ADMIN_DETAIL_AFFIX_TOP = 68;

export const GALLERY_IMAGE_ACCEPT =
  '.png,.jpg,.jpeg,.svg,image/png,image/jpg,image/jpeg,image/svg+xml';

export const REACT_APP_AWS_ACCESS_KEY_ID =
  process.env.REACT_APP_AWS_ACCESS_KEY_ID;

export const BALANCE_QUALIFY_LINK = {
  above50k:
    'https://qualification.sandbox.getbalance.com/pending?qid=b55f1c41-873f-459e-b160-d1096f37699b',
  below50k:
    'https://qualification.sandbox.getbalance.com/completed?qid=74482632-2880-4aba-b505-30cb48ce3a3b',
};

export const QUANTITY_DEBOUNCE_MILLISECOND = 1500;

export const PRICE_GUARANTEE_HOURS = 336;

export const SYSTEM_UNAVAILABLE_STATUS_KEY = 'systemUnavailableStatus';

export const DEFAULT_PLACEHOLDER = '--';

export const JOB_ADJUSTMENT_WORKSPACE_FILTER = 'jobAdjustmentWorkspaceFilter';

export const JOB_ADJUSTMENT_AFTER_TIME = '2022-12-05T00:22:17Z';

export const WORKSPACE_DELAY_TIME = 3000;

export const NOT_APPLICABLE = 'N/A';

export const STATIC_PAGE_URL = 'https://www.revshop.com';

export const STATIC_PAGE_URL_RESELLER = `${STATIC_PAGE_URL}/reseller-certificates.html`;

export const ALBERTSONS_ORGS = (
  process.env.REACT_APP_ALBERTSONS_ORGS || '40,41,42,43'
)
  .split(',')
  .map((id) => Number(id.trim()))
  .filter((id) => !isNaN(id));

export const CHECKOUT_ALBERTSONS_ORGS = (
  process.env.REACT_APP_CHECKOUT_ALBERTSONS_ORGS || '40,41'
)
  .split(',')
  .map((id) => Number(id.trim()))
  .filter((id) => !isNaN(id));

export const CANVA_ORGS = (process.env.REACT_APP_CANVA_ORGS || '754')
  .split(',')
  .map((id) => Number(id.trim()))
  .filter((id) => !isNaN(id));

/**
 * Zendesk request form a buyer is sent to when the gallery has no SKU for what they need.
 * Setting up a base SKU is not self-serve, so the request doubles as a sales signal.
 */
export const PRODUCT_REQUEST_URL =
  process.env.REACT_APP_PRODUCT_REQUEST_URL ||
  'https://revshop.zendesk.com/hc/en-us/requests/new?ticket_form_id=48248729416845&tf_subject=RevShop+Product+Request&tf_description=Please+contact+me+to+set+up+another+product+on+my+RevShop+account%3A+%5BName+of+Product%5D';

/**
 * PRD-471: Zendesk request form behind "Contact Revshop", shown in place of Add to Cart when the
 * Industry Average org fulfils a job configuration and the network admin disabled Add to Cart for
 * it. No ticket_form_id yet, so this lands on Zendesk's default form with the subject prefilled.
 */
export const JOB_CONFIG_ASSISTANCE_URL =
  process.env.REACT_APP_JOB_CONFIG_ASSISTANCE_URL ||
  'https://revshop.zendesk.com/hc/en-us/requests/new?tf_subject=Job+Configuration+Assistance&tf_description=Please+contact+me+for+assistance+with+this+job+configuration.';
